/*
 * AuthPage Messages
 *
 * This contains all the text for the AuthPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.AuthPage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the AuthPage container!',
  },
  inexistent_user:
    'El correo con el que ingresas no esta registrado, consulta a un administrador',
  loading: 'Consultando los datos del usuario',
});
